import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_CODES } from '@ddt-web/config';
import { ApplicationNames } from '@ddt-web/domain';
import * as get from 'lodash/get';
import * as isArray from 'lodash/isArray';

import { ErrorObject, PopupErrorObject } from '../models';
import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

@Injectable()
export class PacErrorHandlerService extends AbstractErrorHandlerService {
	private hardStopConfigs = ['associatedPortfolios', 'engagementPortfolios', 'details'];

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error): void {
		if (error instanceof ErrorObject && this.hardStopConfigs.includes(error.configName)) {

			const isDataReturnedWithSingleError = !get(error, 'responseJson.allDataReturned') && !isArray(error.responseJson.errorCodes);
			const unhandledErrorCodes = [
				ERROR_CODES.PORTFOLIO_ANALYSIS_HOLDING_NOT_FOUND,
				ERROR_CODES.HOLDINGS_TOTAL_WEIGHT_ERROR,
				ERROR_CODES.SERIALIZATION_LIMIT,
				ERROR_CODES.SECURITY_NOT_FOUND
			];
			const isUnhandledError = isArray(error.responseJson.errorCodes) && Array.of(...error.responseJson.errorCodes).some(errorObj => unhandledErrorCodes.includes(errorObj));

			if (isDataReturnedWithSingleError || isUnhandledError) {
				// the PORTFOLIO_ANALYSIS_HOLDING_NOT_FOUND error will be handled by MissingHoldingErrorHandlerService which needs a PopupErrorObject
				// the HOLDINGS_TOTAL_WEIGHT_ERROR error will be handled by HoldingsTotalWeightErrorHandlerService which needs a PopupErrorObject
				// if responseJson has an errorCodes object, it is a portfolio with PORTFOLIO_NOT_FOUND error code which will be handled by NotFoundErrorHandlerService which needs a PopupErrorObject
				this.nextHandler.handleError(new PopupErrorObject(error.responseJson, error.configName, ApplicationNames.PORTFOLIO_ANALYSIS_CONSTRUCTION));
			}
		} else {
			this.nextHandler.handleError(error);
		}
	}
}
